import { render } from "./MenuSessionTemplateActions.vue?vue&type=template&id=0137528c&scoped=true"
import script from "./MenuSessionTemplateActions.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MenuSessionTemplateActions.vue?vue&type=script&charset=utf-8&lang=js"

import "./MenuSessionTemplateActions.vue?vue&type=style&index=0&id=0137528c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0137528c"]])

export default __exports__